import {
	SEND_EMAIL, 
	SEND_EMAIL_SUCCESS, 
	SEND_EMAIL_FAIL 
} from "./Constants"

const initialState = {
		emailIsLoading: false,
		error: null,
		emailData: null
}
export default function reducer(state = initialState, action) {
	switch(action.type) {
		case SEND_EMAIL:
			return {
				...state,
					emailIsLoading: true
			}
		case SEND_EMAIL_SUCCESS:
			return {
				...state,
					emailIsLoading: false,
					emailData: action.payload
			}
		case SEND_EMAIL_FAIL:
			return {
				...state,
				emailIsLoading: false,
				error: action.payload
			}
		default:
			return state;
	}
}